import {ModuleWithProviders, NgModule} from '@angular/core';
import {sharedServices} from '../services/services';
import {EloquentManagerService} from '../eloquent/providers/eloquent-manager.provider';
import {Gatekeeper} from '../guards/gatekeeper.guard';
import {PaginationModule} from '../components/pagination/pagination.module';
import {SharedImportsModule} from './shared-imports.module';
import {DynamicComponentModule} from '../components/dynamic-component/dynamic-component.module';
import {UploaderModule} from '../components/uploader/uploader.module';
import {ConfirmationModule} from '../components/confirmation/confirmation.module';
import {ToastModule} from '../services/toast/toast.module';

@NgModule({
    declarations: [],
    imports: [],
    exports: [
        SharedImportsModule,
        PaginationModule,
        DynamicComponentModule,
        ConfirmationModule,
        UploaderModule,
        ToastModule,
    ],
    providers: []
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                Gatekeeper,
                EloquentManagerService,
                ...sharedServices,
            ]
        };
    }
}






// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/modules/shared.module.ts